"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _domElement = _interopRequireDefault(require("../../utils/propTypes/domElement"));

var PortalLayer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(PortalLayer, _React$Component);

  function PortalLayer() {
    (0, _classCallCheck2.default)(this, PortalLayer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PortalLayer).apply(this, arguments));
  }

  (0, _createClass2.default)(PortalLayer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
          element = _this$props.element,
          renderTree = _this$props.renderTree;
      var closeTransitionTree = renderTree(null, true);
      if (!closeTransitionTree) return;
      var originalTransitionContents = Array.prototype.map.call(element.firstChild.children, function (childElement) {
        return childElement.cloneNode(true);
      });
      var closeTransitionContainer = document.createElement('div');
      element.appendChild(closeTransitionContainer);
      (0, _reactDom.render)(closeTransitionTree, closeTransitionContainer, function () {
        originalTransitionContents.forEach(function (el) {
          return closeTransitionContainer.firstChild.appendChild(el);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          element = _this$props2.element,
          renderTree = _this$props2.renderTree;
      var tree = renderTree(children);
      return (0, _reactDom.createPortal)(tree, element);
    }
  }]);
  return PortalLayer;
}(_react.default.Component);

PortalLayer.propTypes = {
  children: _propTypes.default.node.isRequired,
  element: _domElement.default.isRequired,
  renderTree: _propTypes.default.func.isRequired
};
var _default = PortalLayer;
exports.default = _default;
module.exports = exports.default;